/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdrOrgProperties } from './vcdrOrgProperties';


export interface VcdrOrgInfo { 
    /**
     * Org UUID
     */
    org_id: string;
    /**
     * VCDR Tenant org Name
     */
    org_name: string;
    org_properties: VcdrOrgProperties;
}

